import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import { sessionActions } from '../model/session.slice';
import { store } from '~shared/store';
import {
  transformLastBookingDtoToLastBooking,
  transformSessionDtoToSession,
} from '../lib/session.mappers';
import { getLastBooking, getSession } from '~shared/api/api.service';
import { bookingActions } from '~processes/booking/model/booking.slice';
import { transformCartItemToBookingRoom } from '~entities/offer/lib/offer.mappers';
import { Locale } from '~app/i18n';
import { useLocale } from '~shared/hooks/use-locale';

export const SESSION_ROOT_QUERY_KEY = ['session'] as const;

export const sessionQueryOptions = (locale: Locale = 'en') =>
  queryOptions({
    queryKey: [...SESSION_ROOT_QUERY_KEY, locale],
    queryFn: ({ signal }) =>
      getSession(locale, { signal }).then(({ data }) => {
        const session = transformSessionDtoToSession(data);
        store.dispatch(sessionActions.setSession(session.sessionId));

        store.dispatch(
          bookingActions.updateRooms(
            session.cart.map(transformCartItemToBookingRoom).reverse(),
          ),
        );
        return session;
      }),
  });

export const useSession = () => {
  const locale = useLocale();

  return useSuspenseQuery(sessionQueryOptions(locale));
};

export const lastBookingQueryOptions = (locale: Locale = 'en') =>
  queryOptions({
    queryKey: [...SESSION_ROOT_QUERY_KEY, 'last-booking', locale],
    queryFn: ({ signal }) =>
      getLastBooking(locale, { signal }).then(({ data }) => {
        return transformLastBookingDtoToLastBooking(data);
      }),
  });

export const useLastBooking = () => {
  const locale = useLocale();

  return useQuery(lastBookingQueryOptions(locale));
};
